import { format, parseISO, isValid } from "date-fns";

export const formatToUSDate = (dateValue) => {
  if (!dateValue) return "-";

  let dateObj;
  if (dateValue instanceof Date) {
    dateObj = dateValue;
  } else {
    // If it's an ISO string like "2004-07-14T00:00:00.000Z", we want to keep 07/14/2004
    // Using UTC methods avoids the local timezone shift.
    dateObj = parseISO(dateValue);
    if (!isValid(dateObj)) dateObj = new Date(dateValue);
  }

  if (!isValid(dateObj)) return "-";

  // Using UTC methods to extract month, day, and year
  const mm = String(dateObj.getUTCMonth() + 1).padStart(2, "0");
  const dd = String(dateObj.getUTCDate()).padStart(2, "0");
  const yyyy = dateObj.getUTCFullYear();

  return `${mm}/${dd}/${yyyy}`;
};

export const formatToUSDateTime = (dateValue) => {
  if (!dateValue) return "-";

  let dateObj;
  if (dateValue instanceof Date) {
    dateObj = dateValue;
  } else {
    dateObj = parseISO(dateValue);
    if (!isValid(dateObj)) dateObj = new Date(dateValue);
  }

  if (!isValid(dateObj)) return "-";

  // Detect if the time is exactly midnight (00:00:00)
  const isMidnight =
    dateObj.getUTCHours() === 0 &&
    dateObj.getUTCMinutes() === 0 &&
    dateObj.getUTCSeconds() === 0;

  // If midnight, return only date
  if (isMidnight) {
    return format(dateObj, "MM/dd/yyyy");
  }

  // Otherwise include time
  return format(dateObj, "MM/dd/yyyy hh:mm a");
};

export const formatToDate = (dateValue) => {
  if (!dateValue) return "-";
  let dateObj;
  if (dateValue instanceof Date) {
    dateObj = dateValue;
  } else {
    dateObj = parseISO(dateValue);
    if (!isValid(dateObj)) dateObj = new Date(dateValue);
  }
  if (!isValid(dateObj)) return "-";
  return format(dateObj, "dd");
};

export const formatToMonth = (dateValue) => {
  if (!dateValue) return "-";
  let dateObj;
  if (dateValue instanceof Date) {
    dateObj = dateValue;
  } else {
    dateObj = parseISO(dateValue);
    if (!isValid(dateObj)) dateObj = new Date(dateValue);
  }
  if (!isValid(dateObj)) return "-";
  return format(dateObj, "MMM");
};

export const formatToYear = (dateValue) => {
  if (!dateValue) return "-";
  let dateObj;
  if (dateValue instanceof Date) {
    dateObj = dateValue;
  } else {
    dateObj = parseISO(dateValue);
    if (!isValid(dateObj)) dateObj = new Date(dateValue);
  }
  if (!isValid(dateObj)) return "-";
  return format(dateObj, "yyyy");
};

export const calculateCountdown = (startDate) => {
  const now = new Date();
  const eventDate = new Date(startDate);

  if (isNaN(eventDate.getTime())) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  }

  const diff = eventDate - now;

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);

  return {
    days: days >= 0 ? days : 0,
    hours: hours >= 0 ? hours : 0,
    minutes: minutes >= 0 ? minutes : 0,
    seconds: seconds >= 0 ? seconds : 0,
  };
};

export const getAge = (dob) => {
  if (!dob) return 0;

  const birthDate = new Date(dob);
  const today = new Date();

  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();

  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
};

export const normalizeDateToUTC = (date) => {
  if (!date) return null;
  const d = new Date(date);
  return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())).toISOString();
};
